import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ChevronDown } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQAccordionProps {
  items: FAQItem[];
}
const FAQAccordion: React.FC<FAQAccordionProps> = ({
  items
}) => {
  if (!items || items.length === 0) return null;

  return (
    <Accordion type="single" collapsible className="w-full space-y-3">
      {items.map((item, index) => (
        <AccordionItem key={index} value={`item-${index}`} className="border border-joerg-200 rounded-lg bg-white overflow-hidden">
          <AccordionTrigger className="px-6 py-4 text-left hover:bg-joerg-50 transition-colors duration-200 [&[data-state=open]>svg]:rotate-180">
            <span className="text-joerg-800 font-medium text-base">{item.question}</span>
          </AccordionTrigger>
          <AccordionContent forceMount className="px-6 pb-4 text-joerg-700 leading-relaxed">
            <span dangerouslySetInnerHTML={{ __html: item.answer }} />
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
export default FAQAccordion;